module.exports = __webpack_public_path__ + "img/compresor-4.19ed50f5.png";